import React from 'react';
import {
  Container, Row, Col, Alert, Button,
} from 'react-bootstrap';
import styled, { css } from 'styled-components';
import {green, qaLink} from '../../styles/constants';
import Step from '../../components/Step';
import ArrowLink from '../../components/ArrowLink';
import { Link } from 'react-router-dom';

// Illustrations
import beesIllustration from '../../assets/illustrations/bees.svg';
import stepOneIllustration
  from '../../assets/illustrations/frontpage_step_1.svg';
import stepTwoIllustration
  from '../../assets/illustrations/frontpage_step_2.svg';
import stepThreeIllustration
  from '../../assets/illustrations/frontpage_step_3.svg';
import stepFourIllustration
  from '../../assets/illustrations/frontpage_step_4.svg';

import firstDecorative from '../../assets/decorative/frontpage_topright.svg';
import secondDecorative from '../../assets/decorative/frontpage_left.svg';
// Logos
import waarnemingenLogo
  from '../../assets/logos/waarnemingen.png';
import ecogoggleLogo from '../../assets/logos/ecogoggle.png';
import naturalisLogo from '../../assets/logos/naturalis.png';
import lnvLogo from '../../assets/logos/lnv.png';
import UpdateBar from "../../components/UpdateBar";
import LinkButton from "../../components/LinkButton";
// import Footer from '../../components/Footer';

const lightGreen = '#FBFDFC';

const Wrap = styled.div`
  width: 100%;
  background-color: ${(props) => props.backgroundColor && props.backgroundColor};
  position: relative;
`;

const NaturalisLogo = styled.img`
  height: 70px;
  width: auto;
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 2rem;
  
   @media (min-width: 768px) { 
    font-size: 4rem;
   }
`;

const PartnerLogo = styled.img`
  height: auto;
  width: 50%;
  margin-bottom: 3rem;
  
  @media (min-width: 768px) { 
    width: 90%;
    height: auto;
    margin-bottom: 0;
  }
`;

const Subtitle = styled.h2`
  font-weight: 600;
  font-size: 1.2rem;
  
  @media (min-width: 768px) { 
    font-size: 1.4rem;
  }
`;

const Intro = styled.p`
  line-height: 1.6rem;
`;

const BeesImage = styled.img`
  width: 100%;
  height: auto;
`;

const Hr = styled.hr`
  border-top: 3px solid ${green};
  width: 50px;
  display: inline-block;
`;

const SectionHeading = styled.h3`
  font-weight: 600;
  font-size: 1.5rem;
`;

const decorativeNotOnMobile = css`
  @media (max-width: 1400px) { 
    display: none;
   }
`;

const FirstDecorativeImageWrapper = styled.div`
  ${decorativeNotOnMobile};
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
`;

const SecondDecorativeImageWrapper = styled.div`
  ${decorativeNotOnMobile};
  position: absolute;
  top: -30%;
  left: 0;
  height: 150%;
`;

const DecorativeImage = styled.img`
  height: 100%;
  width: auto;
`;

const Frontpage = () => (
  <>
    <Wrap>
      {/*<UpdateBar />*/}
      <FirstDecorativeImageWrapper>
        <DecorativeImage src={firstDecorative} />
      </FirstDecorativeImageWrapper>
      <Container>
        <Row className="pt-5 mb-5">
          <Col md={2}>
            <NaturalisLogo src={naturalisLogo} alt="Logo Naturalis" />
          </Col>
        </Row>
        <Row>
          <Col>
            <Title>
              Bijvriendelijk beplanten
            </Title>
            <Subtitle>
              Geïnitieerd door het hart, ondersteund door de
              wetenschap
            </Subtitle>
            <Hr />
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <Intro>
              Net als jij en ik verschillen bijen in het voedsel dat ze eten. Bijensoorten verschillen bovendien in de periode in het jaar dat ze vliegen. Het is belangrijk dat er gedurende deze vliegperioden van alle bijen voldoende en divers voedsel voor ze is in de vorm van nectar en stuifmeel. Jij kunt daarbij helpen door het maken van een bloeiboog: een samenstelling van verschillende wilde planten met verschillende bloeiperiodes door het jaar heen om de verschillende bijensoorten van voedsel te voorzien. Hiervoor kun je deze bloeibogen app gebruiken!
            </Intro>
            <Intro>
              De Bloeibogen app maakt de voorkomende bijensoorten en hun voedselbeschikbaarheid in je geselecteerde gebied inzichtelijk en geeft je gericht plantadvies.
            </Intro>
            <Intro>
              De tool maakt gebruik van verspreidings- en interactiemodellen van de bijensoorten en hun voedselplanten en is ontwikkeld door de wetenschappers van Naturalis Biodiversity Center en Ecogoggle.
            </Intro>
          </Col>
          <Col md={2} className="offset-md-1 d-xs-none d-sm-none d-md-flex">
            <BeesImage src={beesIllustration} alt="Bijen illustratie" />
          </Col>
        </Row>
        <Row className="mb-5 mt-4">
          <Col>
            <Button as={Link} to="/select-area">Aan de slag</Button>
          </Col>
        </Row>
      </Container>
    </Wrap>
    <Wrap backgroundColor={lightGreen}>
      <SecondDecorativeImageWrapper>
        <DecorativeImage src={secondDecorative} />
      </SecondDecorativeImageWrapper>
      <Container className="pt-5 pb-5">
        <Row className="mb-3">
          <Col className="text-center">
            <SectionHeading>Hoe werkt het?</SectionHeading>
          </Col>
        </Row>
        <Row>
          <Col md className="mb-5">
            <Step
              number={1}
              image={stepOneIllustration}
              heading="Selecteer een gebied"
              text="Snel en gemakkelijk"
            />
          </Col>
          <Col md className="mb-5">
            <Step
              number={2}
              image={stepThreeIllustration}
              heading="Bepaal de bijensoorten"
              text="De modellen voorspellen of een bijensoort voor kan komen in jouw gebied."
            />
          </Col>
          <Col md className="mb-5">
            <Step
              number={3}
              image={stepTwoIllustration}
              heading="Huidige beplanting ingeven"
              text="Handmatig of automatisch met behulp van de modellen."
            />
          </Col>
          <Col md className="mb-5">
            <Step
              number={4}
              image={stepFourIllustration}
              heading="Maak je bloeiboog"
              text="Samengesteld op basis van je doelsoorten en bloeiboog huidige beplanting."
            />
          </Col>
        </Row>
        <Row>
          <Col className="text-center small">
            <p>
              De informatie over de planten, bijen en hun interactie is afkomstig uit gegevens van Naturalis, de NDFF, EIS Kenniscentrum Insecten, www.waarneming.nl en het Nederlands soortenregister.
            </p>
          </Col>
        </Row>
        <Row className="text-center mt-3 mb-3">
          <Col>
            <Button as={Link} to="/select-area">Aan de slag</Button>
          </Col>
        </Row>
      </Container>
    </Wrap>
    <Wrap>
      <Container className="pt-5 pb-5 text-center">
        <Row className="mb-5">
          <Col className="text-center">
            <SectionHeading>Q&A</SectionHeading>
            <p>
              Alles weten over hoe de tool werkt? Welke afwegingen er gemaakt zijn en waar je
              rekening mee moet houden? lees dan
              {' '}
              <a
                href={qaLink}
                target="_blank"
                rel="noreferrer"
              >
                deze Q&A
              </a>
              .
            </p>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <SectionHeading>Partners</SectionHeading>
          </Col>
        </Row>
        <Row className="justify-content-center align-items-center d-flex">
          <Col md={3} className="justify-content-center">
            <PartnerLogo
              src={lnvLogo}
              alt="Logo Ministerie van Landbouw, Natuur en Voedselkwaliteit"
            />
          </Col>
          <Col md={3} className="justify-content-center">
            <PartnerLogo
              src={waarnemingenLogo}
              alt="Logo waarnemingen.nl"
            />
          </Col>
          <Col md={3} className="justify-content-center">
            <PartnerLogo
              src={ecogoggleLogo}
              alt="Logo ecogoggle"
            />
          </Col>
        </Row>
      </Container>
    </Wrap>
    {/*<Footer/>*/}
  </>
);

export default Frontpage;
